import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-seguridad',
  templateUrl: './seguridad.component.html',
  styleUrls: ['./seguridad.component.css']
})
export class SeguridadComponent implements OnInit {

  constructor(private _userService: UserService) { }
  actual = environment.actual
  seguridadConfig 

  ngOnInit() {
    this.seguridadConfig = JSON.parse(this._userService.GetsessionStorage('config'));
  }

}
